import Swiper from 'swiper';
import 'swiper/swiper-bundle.css';

export default class LargeInlineCarousel {
  constructor({ el }) {
    this.el = el;
    this.carouselEl = this.el.querySelector('.swiper');

    this.init();
  }

  init() {
    if (this.carouselEl) {
      this.carousel = new Swiper(this.carouselEl, {
        loop: true,
        slidesPerView: 1.1,
        spaceBetween: 12.5,
        breakpoints: {
          1024: {
            slidesPerView: 2.2,
            spaceBetween: 12.5,
          },
        },
      });

      this.carousel.on('slideChange', () => {
        this.dotButtons.forEach((button) => {
          button.classList.remove('active');
        });

        this.dotButtons[this.carousel.realIndex].classList.add('active');
      });

      this.prev = this.el.querySelector('.prev');
      this.next = this.el.querySelector('.next');
      this.dotButtons = Array.from(this.el.querySelectorAll('.dot-button'));

      if (this.prev) {
        this.prev.addEventListener('click', () => {
          this.carousel.slidePrev();
        });
      }

      if (this.next) {
        this.next.addEventListener('click', () => {
          this.carousel.slideNext();
        });
      }

      this.dotButtons.forEach((button, index) => {
        button.addEventListener('click', () => {
          this.carousel.slideToLoop(index);
        });
      });
    }
  }
}
